// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__8fuVK","spinner":"Loading_spinner__Y9jaO"};